import { useEffect } from "react"
import "./PrivacyPolicy.css"

export default function PrivacyPolicy() {
  useEffect(() => {
    // Initialize Bootstrap scrollspy
    // Since Bootstrap is already loaded in app.js, we can use it directly
    if (typeof document !== "undefined" && typeof window !== "undefined") {
      // Wait for DOM to be fully loaded
      setTimeout(() => {
        try {
          const scrollSpyElement = document.body
          if (scrollSpyElement && window.bootstrap) {
            new window.bootstrap.ScrollSpy(scrollSpyElement, {
              target: "#navbar-example",
            })
          }
        } catch (error) {
          console.error("Error initializing ScrollSpy:", error)
        }
      }, 100)
    }

    // Cleanup function
    return () => {
      if (typeof window !== "undefined" && window.bootstrap && window.bootstrap.ScrollSpy) {
        try {
          const scrollSpyElement = document.body
          const spyInstance = window.bootstrap.ScrollSpy.getInstance(scrollSpyElement)
          if (spyInstance) {
            spyInstance.dispose()
          }
        } catch (error) {
          console.error("Error disposing ScrollSpy:", error)
        }
      }
    }
  }, [])

  return (
    <div className="container-fluid privacy-policy-container mt-5">
      <div className="row">
        <div className="col-md-4 col-lg-3 position-fixed" style={{ maxHeight: "100vh", overflowY: "auto" ,paddingBottom:'1.5rem' }}>
          <nav id="navbar-example" className="navbar flex-column align-items-stretch p-3">
            <nav className="nav nav-pills flex-column">
              <h5 className="mb-3">PRIVACY NOTICE</h5>
              <a className="nav-link" href="#section1">
                1. WHAT INFORMATION DO WE COLLECT?
              </a>
              <a className="nav-link" href="#section2">
                2. HOW DO WE PROCESS YOUR INFORMATION?
              </a>
              <a className="nav-link" href="#section3">
                3. WHEN AND WITH WHOM DO WE SHARE YOUR INFORMATION?
              </a>
              <a className="nav-link" href="#section4">
                4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
              </a>
              <a className="nav-link" href="#section5">
                5. HOW LONG DO WE KEEP YOUR INFORMATION?
              </a>
              <a className="nav-link" href="#section6">
                6. HOW DO WE KEEP YOUR INFORMATION SAFE?
              </a>
              <a className="nav-link" href="#section7">
                7. DO WE COLLECT INFORMATION FROM MINORS?
              </a>
              <a className="nav-link" href="#section8">
                8. WHAT ARE YOUR PRIVACY RIGHTS?
              </a>
              <a className="nav-link" href="#section9">
                9. CONTROLS FOR DO-NOT-TRACK FEATURES
              </a>
              <a className="nav-link" href="#section10">
                10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
              </a>
              <a className="nav-link" href="#section11">
                11. LOAN SERVICES  DISCLOSURE
              </a>
              <a className="nav-link" href="#section12">
                12. DO WE MAKE UPDATES TO THIS NOTICE?
              </a>
              <a className="nav-link" href="#section13">
                13. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
              </a>
              <a className="nav-link" href="#section14">
                14. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT?
              </a>
              <a className="nav-link" href="#data-deletion">
                DATA DELETION
              </a>
            </nav>
          </nav>
        </div>

        <div className="col-md-8 col-lg-9 offset-md-4 offset-lg-3">
          <div className="p-4" data-bs-spy="scroll" data-bs-target="#navbar-example" data-bs-offset="0" tabIndex={0}>
            <h1 className="mb-4">PRIVACY NOTICE</h1>

            <div className="mb-4">
              <p>
                Altrange will collect, store, or share your personal data to the Depot for code opening. We use Firebase
                Authentication for user sign-in, but it is used only for authentication purposes.
              </p>

              <h4>Third-Party Services</h4>
              <p>
                We may use third-party services, such as the WhatsApp Business API, to facilitate communication with our
                users. These services may collect and process certain user data to provide their functionality.
              </p>
              <p>
                We ensure that any third-party services we use comply with applicable data protection laws, and we only
                share the necessary information required to provide the service.
              </p>

              <h4>Contact Us</h4>
              <p>
                If you have any questions or concerns about our privacy practices, please contact us at
                support@altrange.com
              </p>

              <h4 id="data-deletion">Data Deletion</h4>
              <ol>
                <ul>
                  <li>
                    Log into your account at{" "}
                    <a
                      href="https://altrange.com"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "blue", textDecoration: "underline" }}
                    >
                      https://altrange.com
                    </a>
                  </li>
                  <li>Navigate to Profile Settings and click on the Delete Account button.</li>
                  <li>
                    A confirmation dialog will appear. Click on the <strong>Yes, Delete Account</strong> button to proceed.
                  </li>
                  <li>
                    After clicking <strong>Yes, Delete Account</strong>, you’ll be prompted to enter your account password for
                    verification.
                  </li>
                  <li>
                    Once the correct password is entered, your account—including all associated data (profile, account
                    details, and site addresses etc.. )—will be permanently deleted within 3 seconds.
                  </li>
                </ul>

              </ol>

              <p>
                Delete your account using web: you will be guided through the process of deleting your account.{" "}
                <a href="https://altrange.com/profile" target="_blank" rel="noreferrer"  style={{ color: 'blue', textDecoration: "underline" }}>click here</a>
              </p>

              <h4>Summary of Key Points</h4>
              <ul>
                <li>
                  <strong>What personal information do we process?</strong> When you visit, use, or navigate our
                  Services, we may process personal information depending on how you interact with Altrange Private
                  Limited and the Services, the choices you make, and the products and features you use.
                </li>
                <li>
                  <strong>Do we process any sensitive personal information?</strong> We do not process sensitive
                  personal information.
                </li>
                <li>
                  <strong>Do we receive any information from third parties?</strong> We do not receive any information
                  from third parties.
                </li>
                <li>
                  <strong>How do we process your information?</strong> We process your information to provide, improve,
                  and administer our Services, communicate with you, for security and fraud prevention, and to comply
                  with the law. We may also process your information for other purposes with your consent. We process
                  your information only when we have a valid legal reason to do so.
                </li>
                <li>
                  <strong>In what situations and with which parties do we share personal information?</strong> We may
                  share information in specific situations and with specific third parties.
                </li>
                <li>
                  <strong>How do we keep your information safe?</strong> We have organizational and technical processes
                  and procedures in place to protect your personal information. However, no electronic transmission over
                  the internet or information storage technology can be guaranteed to be 100% secure.
                </li>
                <li>
                  <strong>What are your rights?</strong> Depending on where you are located geographically, the
                  applicable privacy law may mean you have certain rights regarding your personal information.
                </li>
                <li>
                  <strong>How do you exercise your rights?</strong> The easiest way to exercise your rights is by
                  filling out our data subject request form available at  <a href="https://altrange.com/profile" target="_blank" rel="noreferrer"  style={{ color: 'blue', textDecoration: "underline" }}> http://www.altrange.com/profile</a> , or by
                  contacting us. We will consider and act upon any request in accordance with applicable data protection
                  laws.
                </li>
              </ul>
            </div>

            <h2 id="section1" className="pt-4">
              1. WHAT INFORMATION DO WE COLLECT?
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> We collect personal information that you provide to us.
              </p>
              <p>
                We collect personal information that you voluntarily provide to us when you register on the Services,
                express an interest in obtaining information about us or our products and Services, when you participate
                in activities on the Services, or otherwise when you contact us.
              </p>
              <p>
                The personal information that we collect depends on the context of your interactions with us and the
                Services, the choices you make, and the products and features you use. The personal information we
                collect may include the following:
              </p>
              <ul>
                <li>Names</li>
                <li>Phone numbers</li>
                <li>Email addresses</li>
                <li>Mailing addresses</li>
                <li>Billing addresses</li>
                <li>Contact or authentication data</li>
                <li>Contact preferences</li>
                <li>Job titles</li>
              </ul>
              <p>
                <strong>Sensitive Information.</strong> We do not process sensitive information.
              </p>
              <p>
                All personal information that you provide to us must be true, complete, and accurate, and you must
                notify us of any changes to such personal information.
              </p>

              <h4>Information automatically collected</h4>
              <p>
                <strong>In Short:</strong> Some information — such as your Internet Protocol (IP) address and/or browser
                and device characteristics — is collected automatically when you visit our Services.
              </p>
              <p>
                We automatically collect certain information when you visit, use, or navigate the Services. This
                information does not reveal your specific identity (like your name or contact information) but may
                include device and usage information, such as your IP address, browser and device characteristics,
                operating system, language preferences, referring URLs, device name, country, location, information
                about how and when you use our Services, and other technical information. This information is primarily
                needed to maintain the security and operation of our Services, and for our internal analytics and
                reporting purposes.
              </p>
              <p>Like many businesses, we also collect information through cookies and similar technologies.</p>
              <p>The information we collect includes:</p>
              <ul>
                <li>Log and Usage Data.</li>
                <li>Device Data.</li>
                <li>Location Data.</li>
              </ul>
            </div>

            <h2 id="section2" className="pt-4">
              2. HOW DO WE PROCESS YOUR INFORMATION?
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> We process your information to provide, improve, and administer our Services,
                communicate with you, for security and fraud prevention, and to comply with the law. We may also process
                your information for other purposes with your consent.
              </p>
              <p>
                We process your personal information for a variety of reasons, depending on how you interact with our
                Services, including:
              </p>
              <ul>
                <li>To facilitate account creation and authentication and otherwise manage user accounts.</li>
                <li>To deliver and facilitate delivery of services to the user.</li>
                <li>To respond to user inquiries/offer support to users.</li>
                <li>To send administrative information to you.</li>
                <li>To fulfill and manage your orders.</li>
                <li>To enable user-to-user communications.</li>
                <li>To request feedback.</li>
                <li>To send you marketing and promotional communications.</li>
                <li>To deliver targeted advertising to you.</li>
                <li>To post testimonials.</li>
                <li>To protect our Services.</li>
                <li>To administer prize draws and competitions.</li>
                <li>To evaluate and improve our Services, products, marketing, and your experience.</li>
                <li>To identify usage trends.</li>
                <li>To determine the effectiveness of our marketing and promotional campaigns.</li>
                <li>To comply with our legal obligations.</li>
              </ul>
            </div>

            <h2 id="section3" className="pt-4">
              3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> We may share information in specific situations described in this section
                and/or with the following third parties.
              </p>
              <p>We may need to share your personal information in the following situations:</p>
              <ul>
                <li>
                  <strong>Business Transfers.</strong> We may share or transfer your information in connection with, or
                  during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a
                  portion of our business to another company.
                </li>
                <li>
                  <strong>When we use Google Maps Platform APIs.</strong> We may share your information with certain
                  Google Maps Platform APIs (e.g. Google Maps API, Places API). To find out more about Google's Privacy
                  Policy, please refer to this link.
                </li>
                <li>
                  <strong>Affiliates.</strong> We may share your information with our affiliates, in which case we will
                  require those affiliates to honor this privacy notice. Affiliates include our parent company and any
                  subsidiaries, joint venture partners, or other companies that we control or that are under common
                  control with us.
                </li>
                <li>
                  <strong>Business Partners.</strong> We may share your information with our business partners to offer
                  you certain products, services, or promotions.
                </li>
              </ul>
            </div>

            <h2 id="section4" className="pt-4">
              4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> We may use cookies and other tracking technologies to collect and store your
                information.
              </p>
              <p>
                We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store
                information. Specific information about how we use such technologies and how you can refuse certain
                cookies is set out in our Cookie Notice.
              </p>
            </div>

            <h2 id="section5" className="pt-4">
              5. HOW LONG DO WE KEEP YOUR INFORMATION?
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> We keep your information for as long as necessary to fulfill the purposes
                outlined in this privacy notice unless otherwise required by law.
              </p>
              <p>
                We will only keep your personal information for as long as it is necessary for the purposes set out in
                this privacy notice, unless a longer retention period is required or permitted by law (such as tax,
                accounting, or other legal requirements). No purpose in this notice will require us keeping your
                personal information for longer than six (6) months past the start of the idle period of the user's
                account.
              </p>
              <p>
                When we have no ongoing legitimate business need to process your personal information, we will either
                delete or anonymize such information, or, if this is not possible (for example, because your personal
                information has been stored in backup archives), then we will securely store your personal information
                and isolate it from any further processing until deletion is possible.
              </p>
            </div>

            <h2 id="section6" className="pt-4">
              6. HOW DO WE KEEP YOUR INFORMATION SAFE?
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> We aim to protect your personal information through a system of
                organizational and technical security measures.
              </p>
              <p>
                We have implemented appropriate and reasonable technical and organizational security measures designed
                to protect the security of any personal information we process. However, despite our safeguards and
                efforts to secure your information, no electronic transmission over the Internet or information storage
                technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers,
                cybercriminals, or other unauthorized third parties will not be able to defeat our security and
                improperly collect, access, steal, or modify your information. Although we will do our best to protect
                your personal information, transmission of personal information to and from our Services is at your own
                risk. You should only access the Services within a secure environment.
              </p>
            </div>

            <h2 id="section7" className="pt-4">
              7. DO WE COLLECT INFORMATION FROM MINORS?
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> We do not knowingly collect data from or market to children under 18 years of
                age.
              </p>
              <p>
                We do not knowingly solicit data from or market to children under 18 years of age. By using the
                Services, you represent that you are at least 18 or that you are the parent or guardian of such a minor
                and consent to such minor dependent's use of the Services. If we learn that personal information from
                users less than 18 years of age has been collected, we will deactivate the account and take reasonable
                measures to promptly delete such data from our records. If you become aware of any data we may have
                collected from children under age 18, please contact us at <a href="mailto:support@altrange.com" style={{color:'blue'}}>support@altrange.com</a>
              </p>
            </div>

            <h2 id="section8" className="pt-4">
              8. WHAT ARE YOUR PRIVACY RIGHTS?
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> You may review, change, or terminate your account at any time.
              </p>
              <p>
                If you are located in the EEA or UK and you believe we are unlawfully processing your personal
                information, you also have the right to complain to your local data protection supervisory authority.
                You can find their contact details here.
              </p>
              <p>
                If you are located in Switzerland, the contact details for the data protection authorities are available
                here.
              </p>
              <p>
                <strong>Withdrawing your consent:</strong> If we are relying on your consent to process your personal
                information, which may be express and/or implied consent depending on the applicable law, you have the
                right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us
                by using the contact details provided in the section 'HOW CAN YOU CONTACT US ABOUT THIS NOTICE?' below.
              </p>
              <p>
                However, please note that this will not affect the lawfulness of the processing before its withdrawal
                nor, when applicable law allows, will it affect the processing of your personal information conducted in
                reliance on lawful processing grounds other than consent.
              </p>
              <p>
                <strong>Opting out of marketing and promotional communications:</strong> You can unsubscribe from our
                marketing and promotional communications at any time by clicking on the unsubscribe link in the emails
                that we send, or by contacting us using the details provided in the section 'HOW CAN YOU CONTACT US
                ABOUT THIS NOTICE?' below. You will then be removed from the marketing lists. However, we may still
                communicate with you — for example, to send you service-related messages that are necessary for the
                administration and use of your account, to respond to service requests, or for other non-marketing
                purposes.
              </p>
            </div>

            <h2 id="section9" className="pt-4">
              9. CONTROLS FOR DO-NOT-TRACK FEATURES
            </h2>
            <div className="mb-4">
              <p>
                Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track
                ('DNT') feature or setting you can activate to signal your privacy preference not to have data about
                your online browsing activities monitored and collected. At this stage, no uniform technology standard
                for recognizing and implementing DNT signals has been finalized. As such, we do not currently respond to
                DNT browser signals or any other mechanism that automatically communicates your choice not to be tracked
                online. If a standard for online tracking is adopted that we must follow in the future, we will inform
                you about that practice in a revised version of this privacy notice.
              </p>
            </div>

            <h2 id="section10" className="pt-4">
              10. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> Yes, if you are a resident of California, you are granted specific rights
                regarding access to your personal information.
              </p>
              <p>
                California Civil Code Section 1798.83, also known as the 'Shine The Light' law, permits our users who
                are California residents to request and obtain from us, once a year and free of charge, information
                about categories of personal information (if any) we disclosed to third parties for direct marketing
                purposes and the names and addresses of all third parties with which we shared personal information in
                the immediately preceding calendar year. If you are a California resident and would like to make such a
                request, please submit your request in writing to us using the contact information provided below.
              </p>
              <p>
                If you are under 18 years of age, reside in California, and have a registered account with Services, you
                have the right to request removal of unwanted data that you publicly post on the Services. To request
                removal of such data, please contact us using the contact information provided below and include the
                email address associated with your account and a statement that you reside in California. We will make
                sure the data is not publicly displayed on the Services, but please be aware that the data may not be
                completely or comprehensively removed from all our systems (e.g. backups, etc.).
              </p>
            </div>
             <h2 id="section11" className="pt-4">
              11. Loan Services Disclosure
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> Our company does not provide loans directly. All loan products offered through this Website & App are provided by Utkarsh Small Finance Bank Limited, a financial institution licensed and regulated by the Reserve Bank of India (RBI).
              </p>
              <p>We act solely as a Direct Selling Agent (DSA)/technology partner of Utkarsh Small Finance Bank Limited. Our role is limited to:
                <li>Collecting and securely forwarding customer information and loan applications to Utkarsh Small Finance Bank Limited.</li>
                <li>Facilitating communication between customers and the bank for loan processing.</li>
              </p>
              <p>All decisions regarding loan approval, interest rates, disbursal, and repayment are made exclusively by Utkarsh Small Finance Bank Limited, in accordance with their policies and applicable RBI regulations.</p>
              <p><strong>Lender Details:</strong>
              <li>Name: Utkarsh Small Finance Bank Limited</li>
              <li>CIN: L65992UP2016PLC082804</li>
              <li>RBI License No.: MUM: 125 (issued November 25, 2016 under Section 22(1) of the Banking Regulation Act, 1949)</li>
              <li> Registered Office: Utkarsh Tower, NH-31 (Airport Road) Sehmalpur, Kazi Sarai, Harhua, Varanasi, Uttar Pradesh, India – 221105</li>
              <p>For more details, visit the official website: <a href="https://www.utkarsh.bank" target="_blank" rel="noreferrer" style={{color:'blue', textDecoration:'underline'}}>https://www.utkarsh.bank.</a> </p>
              </p>
             
            </div>

            <h2 id="section12" className="pt-4">
              12. DO WE MAKE UPDATES TO THIS NOTICE?
            </h2>
            <div className="mb-4">
              <p>
                <strong>In Short:</strong> Yes, we will update this notice as necessary to stay compliant with relevant
                laws.
              </p>
              <p>
                We may update this privacy notice from time to time. The updated version will be indicated by an updated
                'Revised' date, and the updated version will be effective as soon as it is accessible. If we make
                material changes to this privacy notice, we may notify you either by prominently posting a notice of
                such changes or by directly sending you a notification. We encourage you to review this privacy notice
                frequently to be informed of how we are protecting your information.
              </p>
            </div>

            <h2 id="section13" className="pt-4">
              13. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
            </h2>
            <div className="mb-4">
              <p>
                If you have questions or comments about this notice, you may email us at support@altrange.com or by post
                to:
              </p>
              <address>
                Altrange Private Limited
                <br />
                Sco 12 Backside Sector 7/C
                <br />
                Madhya Marg
                <br />
                Chandigarh, Chandigarh 160019
                <br />
                India
              </address>
            </div>

            <h2 id="section14" className="pt-4">
              14. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
            </h2>
            <div className="mb-4">
              <p>
                Based on the applicable laws of your country, you may have the right to request access to the personal
                information we collect from you, change that information, or delete it. To request to review, update, or
                delete your personal information, please visit: <a href='https://altrange.com/profile' target="_blank" rel="noreferrer" style={{color:'blue', textDecoration:'underline'}}> altrange.com/profile</a>
              </p>
              <p>Follow the steps:</p>
              <ul>
                <li>
                  <strong>In App:</strong> visit your profile edit profile to change you data and visit settings for
                  option to delete your account.
                </li>
                <li>
                  <strong>In website:</strong> you can visite your profile then edit profile as the profile icon itself
                  and there you will find option for account deletion.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}